export const ID_ALS_WAERE_ES_LEICHT = 1170245;
